import React, {  useEffect } from 'react';
import { shape, string, func, bool } from 'prop-types';

import Modal from 'components/common/Modal/Modal';
import Button from 'components/common/Button/Button';
import PurchaseModal from 'components/payments/PurchaseModal/PurchaseModal';
import Crown from 'components/icons/membership/Crown';
import { celebrityShape } from 'constants/propTypesShapes';
import { useModal, useSession } from 'hooks';
import AuthModal from 'components/user/AuthModal/AuthModal';
import useProfile from 'hooks/users/useProfile';
import { zIndexModalSecond } from 'styles/common/_constants.scss';

const ICON_SIZE = 20;

const UnlockEventButton = ({ celebrity, title, size, onSuccess, smallBoldFont }) => {
  const { toggle: togglePayments, isShowing: isShowingPayments } = useModal();
  const { toggle: toggleAuth, isShowing: isShowingAuth } = useModal();
  const { authenticated } = useSession();

  const showPaymentsModal = () => {
    if (!authenticated) {
        showAuthModal();
    }else{
    togglePayments();
    }
  };

  const {
    profile,
    requestProfile,
  } = useProfile();

  const showAuthModal = () => {
    toggleAuth();
  };

  useEffect(() => {
    console.log("Celebrity Data:", celebrity);
  }, [celebrity]);

  return (
    <>
      <Button
        size={size}
        type="primary"
        title={title}
        icon={<Crown width={ICON_SIZE} height={ICON_SIZE} />}
        onClick={showPaymentsModal}
        smallBoldFont={smallBoldFont}
        className="subscribe-button"
      />
      <Modal hide={togglePayments} isShowing={isShowingPayments}>
        <PurchaseModal celebrity={celebrity} onSuccess={onSuccess} type='event' />
      </Modal>
      <Modal hide={toggleAuth} isShowing={isShowingAuth} zIndex={zIndexModalSecond}>
        <AuthModal isModal onSuccess={requestProfile} />
      </Modal>
    </>
  );
};

UnlockEventButton.defaultProps = {
  size: 'xxsmall',
};

UnlockEventButton.propTypes = {
  celebrity: shape(celebrityShape).isRequired,
  onSuccess: func,
  title: string.isRequired,
  size: string,
  smallBoldFont: bool,
};

export default UnlockEventButton;
